<div class='estadistico-component'>
	<div class="h3 mb2">{{ data.title }}</div>
	<div class="flex flex-wrap">
		<div class="col-6 h1 dato-principal">{{ data.data }}</div>
		<div
			class="col-6 h3 flex"
			[ngClass]="data.direction === 'up' ? 'text-success' : 'text-danger'"
		>
			<mat-icon>arrow_drop_{{ data.direction }}</mat-icon>
			<span class="">{{ data.tendency }}%</span>
		</div>
	</div>
</div>
